import { timeFormatLocale } from 'd3-time-format'
export default {
  search: 'Szukaj...',
  catUfk: 'Kategoria',
  catVienna: 'Klasa aktywów',
  catCompensa: 'Kategoria',
  manUfk: 'Zarządzający',
  manVienna: 'Zarządzający',
  manCompensa: 'Zarządzający',
  cur: 'Waluta',
  selCatUfk: 'Wybierz Kategorię',
  selCatVienna: 'Wybierz klasę aktywów',
  selCatCompensa: 'Wybierz Kategorię',
  selCur: 'Wybierz Walutę',
  selRisk: 'Wybierz Ryzyko',
  nameUfk: 'Nazwa',
  nameVienna: 'UFK',
  nameCompensa: 'Nazwa',
  codeUfk: 'Kod',
  codeVienna: 'Kod',
  codeCompensa: 'Kod',
  valUfk: 'Wartość',
  valVienna: 'Cena Jedn.',
  valCompensa: 'Wartość',
  change: 'Zmiana',
  changeVienna: 'Zmiana w okresie',
  changeCompensa: 'Zmiana w okresie',
  lastValuationDateUfk: 'Data wyceny',
  lastValuationDateVienna: 'Data wyceny',
  lastValuationDateCompensa: 'Data wyceny',
  recentCompensa: 'Zmiana',
  dUfk: '1D',
  dVienna: '1D (%)',
  dCompensa: '1D',
  mUfk: '1M',
  mVienna: '1M (%)',
  mCompensa: 'Miesiąc',
  qUfk: '3M',
  qVienna: '3M (%)',
  qCompensa: '3M',
  hyUfk: '6M',
  hyVienna: '6M (%)',
  hyCompensa: '6M',
  yUfk: '12M',
  yVienna: '12M (%)',
  yCompensa: 'Rok',
  y3Ufk: '36M',
  y3Vienna: '36M (%)',
  y3Compensa: '3 lata',
  y5Ufk: '60M',
  y5Vienna: '60M (%)',
  y5Compensa: '5 lat',
  ytdUfk: 'YTD',
  ytdVienna: 'Od pocz. roku',
  ytdCompensa: 'YTD',
  maxUfk: 'MAX',
  maxVienna: 'MAX',
  maxCompensa: 'Od początku',
  riskUfk: 'Ryzyko',
  riskVienna: 'Ryzyko',
  riskCompensa: 'Ryzyko',
  ufkRiskLevel0: 'Brak',
  ufkRiskLevel1: 'Bardzo Niskie',
  ufkRiskLevel2: 'Niskie',
  ufkRiskLevel3: 'Umiarkowane',
  ufkRiskLevel4: 'Średnie',
  ufkRiskLevel5: 'Całkiem Wysokie',
  ufkRiskLevel6: 'Wysokie',
  ufkRiskLevel7: 'Bardzo Wysokie',
  viennaRiskLevel1: 'Minimalny',
  viennaRiskLevel2: 'Bardzo niski',
  viennaRiskLevel3: 'Niski',
  viennaRiskLevel4: 'Średni',
  viennaRiskLevel5: 'Wysoki',
  viennaRiskLevel6: 'Najwyższy',
  downCSV: 'Pobierz Plik CSV',
  showDet: 'Zobacz Szczegóły',
  initBoxMsg: 'Wybierz fundusz do wyświetlenia',
  selectMsg: 'Zaznacz fundusz',
  unselectMsg: 'Odznacz fundusz',
  selectMsgLimit: 'Zaznaczono maksymalną ilość funduszy',
  filters: 'Filtry',
  chart: 'Wykres',
  panel: 'Panel',
  legend: 'Legenda',
  list: 'Lista Funduszy',
  groupUfk: 'Wg kategorii',
  groupVienna: 'Wg klasy aktywów',
  groupCompensa: 'Wg kategorii',
  ungroup: 'Alfabetycznie',
  valOn: 'Wycena na dzień',
  display: 'Wyświetl',
  unselectAll: 'Odznacz wszystkie fundusze',
  raiseSelected: 'Przenieś zaznaczone fundusze w górę tabeli',
  slot3: 'Zakres trzech miesięcy wstecz',
  slot6: 'Zakres sześciu miesięcy wstecz',
  slot9: 'Zakres dziewięciu miesięcy wstecz',
  slot12: 'Zakres roku wstecz',
  slot36: 'Zakres trzech lat wstecz',
  slotMax: 'Pełny zakres czasu',
  copyLink: 'Kopiuj link',
  copyLinkPop: 'Kopiuj link do schowka',
  copiedLinkPop: 'Skopiowano!',
  returnRate: 'Stopa Zwrotu',
  fundValueToolTipPart1: 'Prezentowana w tabeli wartość jest zaokrąglona do dwóch miejsc po przecinku. Pełna wartość to: ',
  fundValueToolTipPart2: ' i jest także dostępna w pliku CSV.'
}

export const locale = timeFormatLocale({
  'dateTime': '%A, %e %B %Y, %X',
  'date': '%d.%m.%Y',
  'time': '%H:%M:%S',
  'periods': ['AM', 'PM'],
  'days': ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
  'shortDays': ['Niedz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.'],
  'months': ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
  'shortMonths': ['Stycz.', 'Luty', 'Marz.', 'Kwie.', 'Maj', 'Czerw.', 'Lipc.', 'Sierp.', 'Wrz.', 'Paźdz.', 'Listop.', 'Grudz.']
})



// WEBPACK FOOTER //
// ./src/localization/pl.js